import { Card, CardContent, CardHeader, Grid, List } from "@mui/material";
import React, { useEffect, useState } from "react";
import NoticeList from "../NoticeList";
import { observer } from "mobx-react";
import useStore from "../../../helpers/useStore";
import { NoticeContext } from "../../../stores/Notice/notice.provider";
import {
  RenderNoticeTemplateDto,
  UploadDocumentDocuTypeEnum,
  UploadDocumentMetadataDto,
} from "../../../api-client";
import Loading from "../../../molecules/Loading";
import useFileUpload from "../../../molecules/FileUpload";
import { PatientsContext } from "../../../stores/Patients/patients.provider";

interface PatientNoticeCardProps {
  patientId: number;
}
function PatientNoticeCard() {
  const PatientStore = useStore(PatientsContext);
  const { selectedPatientId: patientId } = PatientStore;

  const NoticeStore = useStore(NoticeContext);
  const { fetchPatientNoticeData, renderPatientNoticeTemplate } = NoticeStore;

  const [loading, setLoading] = useState<boolean>(false);
  const { uploadDocument, isUploading } = useFileUpload();

  const handleRenderPatientNoticeTemplate = async (data: RenderNoticeTemplateDto) => {
    setLoading(true);
    await renderPatientNoticeTemplate({ ...data, patientId: Number(patientId) });
    setLoading(false);
  };

  const handlUploadPatientNoticeDocument = async (file: File, noticeDefinitionDataId: string) => {
    const fileMetaData: UploadDocumentMetadataDto = {
      docuType: UploadDocumentDocuTypeEnum.Mitteilung,
      ownerType: "Patient",
      ownerId: patientId as unknown as string,
      makeAccessible: true,
      noticeDefinitionDataId: noticeDefinitionDataId,
    };
    await uploadDocument(file, fileMetaData);
    if (patientId) await fetchPatientNoticeData(patientId);
  };

  return (
    <Grid item xs={12}>
      <Card>
        <CardHeader title="Bekanntmachung" />
        <CardContent>
          {/* Loading state */}
          {/* {loading && <p>Dokumente werden geladen ...</p>} */}

          {/* No documents state */}
          {/* {!loading && documents.length === 0 && <p>Keine Dokumente vorhanden.</p>} */}

          {/* Documents list */}
          <Loading showLoading={loading || isUploading} />
          {NoticeStore.patientNoticeDataArr.length ? (
            <NoticeList
              notices={NoticeStore.patientNoticeDataArr}
              onRenderPatientNoticeTemplate={handleRenderPatientNoticeTemplate}
              onUploadPatientNoticeTemplate={handlUploadPatientNoticeDocument}
            />
          ) : (
            <div>
              <label>Keine Bekanntmachungen</label>
            </div>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
}

export default observer(PatientNoticeCard);
